import * as React from 'react';
import { ExtendedDialog } from '@uifabric/portal-ux/lib/components/ExtendedDialog';
import { PrimaryButton, DialogFooter } from '@fluentui/react';
import { loginToRedirectTenant } from '../../redux';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { connect } from 'react-redux';
import { IRootAccountState } from '../../models';

interface ILeaveOrgSuccessDialogProps {
  readonly targetOrg: string;
}

const LeaveOrgSuccessDialog: React.FC<ILeaveOrgSuccessDialogProps> = ({ targetOrg }) => {
  const [t] = useLocalization('Account');
  const redirect = React.useCallback(() => {
    loginToRedirectTenant();
  }, []);

  return (
    <div>
      <ExtendedDialog
        hidden={false}
        isClickableOutsideFocusTrap={false}
        dialogContentProps={{
          title: t('leaveOrgSuccessTitle'),
          showCloseButton: false
        }}
      >
        <p>{t('leaveOrgSuccessTextP1', { orgName: targetOrg })}</p>
        <p>{t('leaveOrgSuccessTextP2', { orgName: targetOrg })}</p>
        <DialogFooter>
          <PrimaryButton text={t('ok')} onClick={redirect} />
        </DialogFooter>
      </ExtendedDialog>
    </div>
  );
};

const mapStateToProps = (state: IRootAccountState): ILeaveOrgSuccessDialogProps => {
  return {
    targetOrg: state.account.currentOrgDisplayName
  };
};

export const ConnectedLeaveOrgSuccessDialog = connect(mapStateToProps)(LeaveOrgSuccessDialog);
